import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useCachedTexts } from '../hooks/useCachedTexts';
import './ServicesGrid.css';

const ServicesGrid = () => {
  const { t } = useTranslation();
  const { getText } = useCachedTexts('home_what_we_do');
  return (
    <section className="services-grid-section">
      <div className="services-grid-header">
        <h2>{getText('heading', t('home.whatWeDo'))}</h2>
        <p>
          {getText('description', t('home.whatWeDoDescription'))}
        </p>
        <Link to="/about#services" className="services-cta">
          {getText('button', t('home.viewServices'))}
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M5 12h14M12 5l7 7-7 7"/>
          </svg>
        </Link>
      </div>
    </section>
  );
};

export default ServicesGrid;
